import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine, faMicrophone, faHeadphones, faUsers } from "@fortawesome/free-solid-svg-icons";

const whatWeDoItems = [
  { id: 1, icon: faChartLine, title: "Boost Your Streams", description: "Increase your music streams across all major platforms." },
  { id: 2, icon: faMicrophone, title: "Artist Promotion", description: "Get your music in front of the right audience." },
  { id: 3, icon: faHeadphones, title: "Streaming Analytics", description: "Track your music performance with real-time insights." },
  { id: 4, icon: faUsers, title: "Grow Your Fanbase", description: "Expand your audience and gain loyal listeners worldwide." },
];

const WhatWeDo = () => {
  return (
    <div className="max-w-6xl mx-auto py-16 px-6 pt-0 text-center">
      <h2 className="text-3xl font-bold text-yellow-400 mb-8">What We Do</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {whatWeDoItems.map((item) => (
          <div key={item.id} className="flex items-center bg-gray-900 p-6 rounded-lg shadow-lg">
            <FontAwesomeIcon icon={item.icon} className="text-4xl text-yellow-400 mr-6" />
            <div className="text-left">
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-300 mt-2">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatWeDo;
